import { useOnOutsideClick } from './useOnOutsideClick';
import { useOpenAndCloseFocus } from './useOpenAndCloseFocus';
import { useOnEscapePress } from './useOnEscapePress';
import { useAnchoredPosition } from './useAnchoredPosition';
import { useRef } from 'react';
export const useOverlay = ({
  anchorRef,
  positionSettings = {},
  positionDeps,
  returnFocusRef,
  initialFocusRef,
  onEscape,
  ignoreClickRefs,
  onClickOutside
}) => {
  const overlayRef = useRef(null);
  positionSettings.anchorElementRef = anchorRef;
  positionSettings.floatingElementRef = overlayRef;
  useOpenAndCloseFocus({
    containerRef: overlayRef,
    returnFocusRef,
    initialFocusRef
  });
  useOnOutsideClick({
    containerRef: overlayRef,
    ignoreClickRefs,
    onClickOutside
  });
  useOnEscapePress({
    onEscape
  });
  const {
    position
  } = useAnchoredPosition(positionSettings, positionDeps);
  return {
    ref: overlayRef,
    position
  };
};